import { render, staticRenderFns } from "./probation-status-radio.vue?vue&type=template&id=c8582058&"
import script from "./probation-status-radio.vue?vue&type=script&lang=js&"
export * from "./probation-status-radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports